import { CalendarMonth, Content } from "..";
import { useData } from "../../hooks/useData";
import { Header } from "../../layout/Header/Header";
import "./Calendar.scss";

export function Calendar() {
  const { orientation } = useData()

  const holidaysBr = {
    january: [{day: 1, name: "Confraternização universal (元日)", block: true}],
    february: [{day: 17, name: "Carnaval", block: false}],
    april: [
      {day: 3, name: "Sexta-feira Santa", block: false},
      {day: 21, name: "Tiradentes", block: false},
    ],
    may: [{day: 1, name: "Dia do Trabalho", block: false}],
    june: [{day: 4, name: "Corpus Christi", block: false}],
    september: [{day: 7, name: "Independência do Brasil", block: false}],
    october: [{day: 12, name: "Dia de Nossa Senhora Aparecida", block: false}],
    november: [
      {day: 2, name: "Finados", block: false},
      {day: 15, name: "Proclamação da República", block: false},
      {day: 20, name: "Consciência Negra", block: false},
    ],
    december: [{day: 25, name: "Natal", block: false}],
  };

  const holidaysJp = {
    january: [{day: 12, name: "成人の日", block: true}],
    february: [
      {day: 11, name: "建国記念日", block: false},
      {day: 23, name: "天皇誕生日", block: true},
    ],
    march: [{day: 20, name: "春分の日", block: true}],
    april: [{day: 29, name: "昭和の日", block: false}],
    may: [
      {day: 3, name: "憲法記念日", block: false},
      {day: 4, name: "みどりの日", block: false},
      {day: 5, name: "こどもの日", block: false},
    ],
    july: [{day: 20, name: "海の日", block: false}],
    august: [{day: 11, name: "山の日", block: false}],
    september: [
      {day: 21, name: "敬老の日", block: false},
      {day: 22, name: "国民の休日", block: false},
      {day: 23, name: "秋分の日", block: true},
    ],
    october: [{day: 12, name: "スポーツの日", block: false}],
    november: [
      {day: 3, name: "文化の日", block: false},
      {day: 23, name: "動労感謝の日", block: false},
    ],
  };

  return (
    <div className="wrapper">
      
      <Header />
      
      <div className={`calendar ${orientation}`}>
        
        <CalendarMonth
          monthName="january"
          totalDays={31}
          offset={4}
          holidaysBr={holidaysBr.january}
          holidaysJp={holidaysJp.january}
          monthNumber={1}
          featured
          showYear
        />
        <CalendarMonth
          monthName="february"
          totalDays={28}
          offset={0}
          holidaysBr={holidaysBr.february}
          holidaysJp={holidaysJp.february}
          monthNumber={2}
        />
        <CalendarMonth
          monthName="march"
          totalDays={31}
          offset={0}
          holidaysJp={holidaysJp.march}
          monthNumber={3}
        />
        <CalendarMonth
          monthName="april"
          totalDays={30}
          offset={3}
          holidaysBr={holidaysBr.april}
          holidaysJp={holidaysJp.april}
          monthNumber={4}
        />
        <CalendarMonth
          monthName="may" 
          totalDays={31}
          offset={5}
          holidaysBr={holidaysBr.may}
          holidaysJp={holidaysJp.may}
          monthNumber={5}
        />
        <CalendarMonth
          monthName="june"
          totalDays={30}
          offset={1}
          holidaysBr={holidaysBr.june}
          monthNumber={6}
        />
        <CalendarMonth
          monthName="july"
          totalDays={31}
          offset={3}
          holidaysJp={holidaysJp.july}
          monthNumber={7}
        />
        <CalendarMonth
          monthName="august"
          totalDays={31}
          offset={6}
          holidaysJp={holidaysJp.august}
          monthNumber={8}
        />
        <CalendarMonth
          monthName="september"
          totalDays={30}
          offset={2}
          holidaysBr={holidaysBr.september}
          holidaysJp={holidaysJp.september}
          monthNumber={9}
        />
        <CalendarMonth
          monthName="october"
          totalDays={31}
          offset={4}
          holidaysBr={holidaysBr.october}
          holidaysJp={holidaysJp.october}
          monthNumber={10}
        />
        <CalendarMonth
          monthName="november"
          totalDays={30}
          offset={0}
          holidaysBr={holidaysBr.november}
          holidaysJp={holidaysJp.november}
          monthNumber={11}
        />
        <CalendarMonth
          monthName="december"
          totalDays={31}
          offset={2}
          holidaysBr={holidaysBr.december}
          monthNumber={12}
        />

      </div>
    </div>
  )
}
